import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';

const useCreditService = {
  getUserData: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-aos/v1/pub/web_loan_payment', data.data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },

  sendData: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-aos/v1/pub/web_loan_payment?business_key=${data.business_key}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },
};

export const useGetUserData = () => {
  const {
    isLoading: isLoadingGetUserData,
    data: dataGetUserData,
    mutate: getUserDataMutation,
  } = useMutation(['getUserData'], (data: { data: any }) => useCreditService.getUserData(data));

  return { isLoadingGetUserData, dataGetUserData, getUserDataMutation };
};

export const useSendData = () => {
  const {
    isLoading: isLoadingSendData,
    data: dataSendData,
    mutate: sendDataMutation,
  } = useMutation(['getUserData'], (data: { data: any; business_key: string }) => useCreditService.sendData(data));

  return { isLoadingSendData, dataSendData, sendDataMutation };
};
